<div class="custom-dialog">
    <div class="header">
        <span>Project Search</span>
        <span class="close" (click)="onCancel()">x</span>
    </div>
    <table *ngIf="projects" [dtOptions]="dtOptions" datatable class="row-border hover" style="width: 100%">
        <thead>
          <tr>
            <th>Project Name</th>
            <th>Number of Products</th>
            <th>Last Modified</th>
            <th></th>
            <th class="no-sort"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of projects">
              <td>{{p.projectName}}</td>
              <td>{{p.products.length}}</td>
              <td>{{formattedDate(p.updatedDate)}}</td>
              <td>{{p.updatedDate}}</td>
              <td><span class="project-link" (click)="onProjectSelect(p)">View</span></td>
          </tr>
        </tbody>
      </table>
      <app-loading *ngIf="isLoadingProjects"></app-loading>
</div>
  